import React from 'react'

const PreviewHeader = () => (
  <header className="elevation-md-3 bg-blue py-2" data-test="preview-header">
    <h2 className="my-2 text-center text-uppercase text-white">Preview</h2>
  </header>
)

export default PreviewHeader
